import React from 'react';
import { matchPath, withRouter } from 'react-router-dom';
import { TABS_LIST } from './tabs';

function TabView(props) {
  const {
    location: { pathname },
  } = props;

  function getMenu() {
    const some = TABS_LIST.map(tabs => {
      const isMaching = matchPath(pathname, {
        path: tabs.path,
        exact: true,
        strict: false,
      });

      if (isMaching === null) return null;

      return tabs.component;
    });

    return some;
  }

  return <>{getMenu()}</>;
}

export default withRouter(TabView);
